import { makeStyles } from "tss-react/mui";

const styles = makeStyles()((theme: any) => ({
  travelCityListPanel: {
    display: "flex",
    gap: 16,
    flexDirection: "column",
    alignItems: "flex-start",
    boxSizing: "border-box",
    backgroundColor: "rgba(28, 30, 31)",
    minHeight: 600,
    width: "100%",
    borderRadius: 24,
    border: "1px solid #000000",
    padding: "24px 60px",
    overflowX: "auto",

    [theme.breakpoints.down("lg")]: {
      padding: "16px 32px",
    },
  },

  moneyCopyButton: {
    minWidth: 100,
    borderRadius: 16,
    background: "rgb(255, 255, 255, 0.2)",
    textDecoration: "none",
    fontFamily: "Philosopher",
    fontWeight: 900,
    fontSize: 14,
    display: "flex",
    gap: 8,
    padding: "4px 24px",

    "& p": {
      fontSize: 14,
      textTransform: "none",
    },

    "& img": {
      width: 24,
      height: 24,
    },

    "&:disabled": {
      opacity: 0.5,
    },
  },

  travelCityListHeader: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 3fr",
    gap: 16,
    padding: "16px 0",
    width: "100%",
    boxSizing: "border-box",
    minWidth: "720px",

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF40",
    },
  },

  travelCityList: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },

  travelListItem: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 4fr",
    gap: 16,
    alignItems: "center",
    padding: "8px 0",
    width: "100%",
    boxSizing: "border-box",
    minWidth: "720px",
    position: "relative",

    "& a": {
      textDecoration: "none",
      color: theme.palette.text.linkColor,
      fontFamily: "Philosopher",
      fontWeight: 900,
    },

    "& p": {
      fontFamily: "Philosopher",
      fontWeight: 900,
      color: "#FFFFFF",
    },
  },

  travelCityListDivider: {
    width: "100%",
    borderBottom: "1px solid #FFFFFF10",
  },

  travelListItemActions: {
    display: "grid",
    gridTemplateColumns: "2fr 2fr 2fr",
    gap: 16,
    alignItems: "center",

    "& img": {
      width: 24,
      height: 24,
    },
  },

  placeholder: {
    position: "absolute",
    left: -24,
    width: 24,
    height: 24,
  },
}));

export default styles;
